import { ApiResponse } from 'src/domain/api'
import { SalesReportWithTenant } from 'src/slices/services/api'

type DownloadPrerequisites =
  | { success: true; salesReports: SalesReportWithTenant[] }
  | { success: false; message: string }

const failure = (reason?: string): DownloadPrerequisites => ({
  success: false,
  message: `ダウンロードに失敗しました: ${reason}`,
})

export const checkDownloadPrerequisites = (
  salesReports: ApiResponse<SalesReportWithTenant[]>,
  updateTotalsResult: ApiResponse<void>,
  hasStore: boolean
): DownloadPrerequisites => {
  if (!salesReports.success) return failure(salesReports.message)
  if (!salesReports.data) return failure('売上報告を取得できませんでした')
  if (!updateTotalsResult.success) {
    return failure(
      `報告値/確定値の更新に失敗しました: ${updateTotalsResult.message}`
    )
  }
  if (!hasStore) return failure('店舗情報を取得できていません')
  return { success: true, salesReports: salesReports.data }
}
